<template>
  <footer id="contact">
    <div class="footer-content">
      <p class="copyright">
        Copyright@ 2021 Shanhaixingyu-CopyrightRadio and Television Program
        Production License: (Guinan) No. 00075Network Culture Operation
        License:Gui.com.cn(2023)0255-0801 Telecommunications Business
        License:Gui B2-20230098
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterCom',
}
</script>

<style lang="scss" scoped>
footer {
  background-color: #111111;
  .footer-content {
    padding: 49px 0;
    max-width: 1000px;
    margin: 0 auto;
    .copyright {
      color: #fff;
      text-align: center;
    }
  }
}
</style>
